import { useState } from "react";
import "./categoriesDropdown.css";

const CategoriesDropdown = ({ label, categories, showColorSquares = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  const colorList = ["#F9DCD3", "#DBECDD", "#BAE1E8"]; // red, blue, green

  return (
    <div className="my-meetings-div">
      <div className="my-meetings-dropdown-header" onClick={() => setIsOpen(!isOpen)}>
        <span>{label || "Categories"}</span>
        <span className={`arrow ${isOpen ? "open" : ""}`}>▼</span>
      </div>

      {isOpen && (
        <div className="my-meetings-dropdown-content">
          {categories && categories.length > 0 ? (
            categories.map((category, index) => (
              <div key={index} className="category-item">
                {showColorSquares && (
                  <div
                    className="color-square"
                    style={{ backgroundColor: colorList[index % colorList.length] }}
                  />
                )}
                <span>{category}</span>
              </div>
            ))
          ) : (
            <span>No Items Found</span>
          )}
        </div>
      )}
    </div>
  );
};

export default CategoriesDropdown;
